const FormPrivacyPolicy = () => {
    return (
        <div className="container pb-20">
            <iframe
                src="https://submit-irm.trustarc.com/services/validation/e273b98a-f5e5-4d4c-b69c-2ca64ea5f289"
                style={{ border: 'none', height: 1400, width: '100%' }}
            ></iframe>
        </div>
    );
};

export default FormPrivacyPolicy;
